export default __webpack_public_path__ + "media/images/manual/joanr/03-be072fa3bf813db0158cf0283d477a0d.png";